export const RESTO365_USER_MANAGEMENT = 'RESTO365_USER_MANAGEMENT'

// User Management Actions
export const FETCH_CURRENT_USER = `${RESTO365_USER_MANAGEMENT}/fetchCurrentUser`
export const FETCH_OKTA_USERS = `${RESTO365_USER_MANAGEMENT}/fetchOktaUsers`
export const FETCH_RESTO365_USERS = `${RESTO365_USER_MANAGEMENT}/fetchResto365Users`
export const FETCH_RESTO365_USERS_COUNT = `${RESTO365_USER_MANAGEMENT}/fetchResto365UsersCount`
export const CREATE_RESTO365_USER = `${RESTO365_USER_MANAGEMENT}/createResto365User`
export const UPDATE_RESTO365_USER = `${RESTO365_USER_MANAGEMENT}/updateResto365User`
export const UPDATE_USER_STATUS = `${RESTO365_USER_MANAGEMENT}/updateUserStatus`
export const FETCH_USER_TO_EDIT = `${RESTO365_USER_MANAGEMENT}/fetchUserToEdit`

// Role Management Actions
export const FETCH_RESTO365_ROLES = `${RESTO365_USER_MANAGEMENT}/fetchResto365Roles`
export const CREATE_RESTO365_ROLE = `${RESTO365_USER_MANAGEMENT}/createResto365Role`
export const UPDATE_RESTO365_ROLE = `${RESTO365_USER_MANAGEMENT}/updateResto365Role`
export const FETCH_ROLE_TO_EDIT = `${RESTO365_USER_MANAGEMENT}/fetchRoleToEdit`
export const FETCH_ROLE_PERMISSIONS = `${RESTO365_USER_MANAGEMENT}/fetchRolePermissions`
export const FETCH_USER_AUDIT_LOGS = `${RESTO365_USER_MANAGEMENT}/fetchUserAuditLogs`
export const CHECK_ROLE_DUPLICATE = `${RESTO365_USER_MANAGEMENT}/checkRoleDuplicate`

// Area and Restaurant Actions
export const FETCH_RESTO365_AREAS = `${RESTO365_USER_MANAGEMENT}/fetchResto365Areas`
export const FETCH_RESTO365_RESTAURANTS_IN_AREA = `${RESTO365_USER_MANAGEMENT}/fetchResto365RestaurantsInArea`

// History Logs Actions
export const FETCH_HISTORY_LOGS = `${RESTO365_USER_MANAGEMENT}/fetchHistoryLogs`
export const EXPORT_HISTORY_LOGS = `${RESTO365_USER_MANAGEMENT}/exportHistoryLogs`

// Filter Actions
export const FILTER_RESTO365_USERS = `${RESTO365_USER_MANAGEMENT}/filterResto365Users`
export const FILTER_RESTO365_USERS_COUNT = `${RESTO365_USER_MANAGEMENT}/filterResto365UsersCount`

// Restaurant Assignment Actions
export const RESTAURANT_ASSIGNMENT = `${RESTO365_USER_MANAGEMENT}/restaurantAssignment`
